<div class="analytics-card">
  <div class="card-body">
    <div class="card-header-section d-flex justify-content-between align-items-start mb-3">
      <div class="title-container">
        <h5 class="card-title mb-0">Shadow IT Trends</h5>
      </div>
      @if (shadowItTrendsData()?.trendPercentageChange) {
        <div class="trend-indicator">
          <div 
            class="metric-comparison" 
            [class.up]="isTrendUp" 
            [class.down]="isTrendDown"
          >
            <span>{{ trendIcon }}</span>
            {{ formattedTrendChange }}
          </div>
        </div>
      }
    </div>

    @if (shadowItTrendsData(); as data) {
      <!-- Category Breakdown -->
      <div class="category-breakdown mb-3">
        <h6 class="breakdown-title mb-2">Category Breakdown</h6>
        <div class="category-grid">
          @for (category of categories; track category.category) {
            <div class="category-item">
              <div class="category-indicator">
                <span class="category-dot" [style.background-color]="category.color"></span>
                <span class="category-name">{{ category.category }}: {{ category.percentage }}%</span>
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Chart Section -->
      <div class="chart-section">
        <div 
          class="shadow-it-chart"
          echarts 
          [options]="chartOptions"
          [initOpts]="{ renderer: 'canvas' }"
        ></div>
      </div>
    } @else {
      <!-- Loading/No Data State -->
      <div class="no-data-state">
        <p class="text-muted">No Shadow IT trends data available</p>
      </div>
    }
  </div>
</div>
